
<template>
    <div class="page-title-container">
        <h1 class='page-title-style'> {{title}}</h1>
    </div>
</template>

<script>
    export default {
        props:{
            title:{
                type: String,
            }  
        },
    };
</script>

<style  lang="scss" scoped>
    .page-title-container{
        text-align: left;
        margin-top: 50px;
        margin-bottom: 20px;
        margin-left: 10px;
        @media screen and (max-width:900px) {
            margin-top: 30px;
        }

        @media screen and (min-width:768px) {
            margin-left: 50px;
        }

        .page-title-style{
            @include f-carousel-title;
            color: black;
        }
        
      
    }
  
</style>